import { useState } from '../c-mp/fun/useState'
import { QuizDifficulty } from '../fun/makeQuizQuestions'
import type { IQuizQuestion } from './IQuizQuestion'

export const quizState = useState('quizState', {
	questions: undefined as undefined | IQuizQuestion[],
	questionIndex: 0,
	showCorrect: false,
	difficulty: QuizDifficulty.ParditkaAlive,
})
